// extracted by mini-css-extract-plugin
module.exports = {"headerContainerDiv":"Header_headerContainerDiv__XTyRJ","linkContainerDiv":"Header_linkContainerDiv__3IMwr","link":"Header_link__1rRO8"};